import { useQuery } from "react-query";

import { searchService } from "services";

type UsePendSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const usePendSearchQuery = ({
	pattern,
	page,
	options,
}: UsePendSearchQueryProps) =>
	useQuery(
		["pendSearch", pattern, page],
		() =>
			searchService.getPends({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default usePendSearchQuery;
